import React, { useState } from 'react';
import { Form, Typography } from 'antd';
import { Input, Button, Checkbox } from '@gamesb42/ui-kit';

const { Title, Text, Link } = Typography;

interface InvitePasswordFormData {
  password: string;
  confirmPassword: string;
  agree: boolean;
}

interface InvitePasswordFormProps {
  form: any;
  loading: boolean;
  onFinish: (values: InvitePasswordFormData) => void;
}

const InvitePasswordForm: React.FC<InvitePasswordFormProps> = ({ form, loading, onFinish }) => {
  const [isAgreed, setIsAgreed] = useState(false);

  return (
    <>
      <Title level={2} style={{ marginBottom: '20px', textAlign: 'left' }}>
        Set Your Password
      </Title>

      <div style={{ marginBottom: '32px' }}>
        <Text style={{ color: '#606176' }}>Create a strong password with a mix of letters, numbers and symbols</Text>
      </div>

      <Form form={form} layout="vertical" onFinish={onFinish} size="large">
        <Form.Item
          name="password"
          rules={[
            { required: true, message: 'Please input your password' },
            {
              min: 8,
              pattern: /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/,
              message:
                'Password must be at least 8 characters and contain letters, numbers, and special characters (@$!%*#?&)',
            },
          ]}
        >
          <Input
            label="New Password"
            placeholder="Password*"
            size="large"
            type="password"
            autoComplete="new-password"
          />
        </Form.Item>

        <Form.Item
          name="confirmPassword"
          dependencies={['password']}
          rules={[
            { required: true, message: 'Please confirm your password!' },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue('password') === value) {
                  return Promise.resolve();
                }
                return Promise.reject(new Error('The two passwords do not match!'));
              },
            }),
          ]}
        >
          <Input
            label="Confirm Password"
            placeholder="Confirm Password*"
            size="large"
            type="password"
            autoComplete="new-password"
          />
        </Form.Item>

        <Form.Item
          name="agree"
          valuePropName="checked"
          rules={[
            {
              validator: (_, value) =>
                value ? Promise.resolve() : Promise.reject(new Error('You must agree to the terms')),
            },
          ]}
          style={{ marginBottom: '32px' }}
        >
          <Checkbox
            onChange={(e) => setIsAgreed(e.target.checked)}
            style={{
              alignItems: 'flex-start',
              color: 'var(--grey-gray-10-blue-grey, #686F88)',
              fontFamily: 'Muller',
              fontSize: '14px',
              fontStyle: 'normal',
              fontWeight: 400,
              lineHeight: '20px',
              textAlign: 'justify',
              paddingRight: 0,
            }}
          >
            By clicking the "Set Password" button, you are creating a GamesBoost42 account, and you agree to
            GamesBoost42's{' '}
            <Link
              href="https://id.gamesboost42.com/resources/mm3fq/login/factoring/pdf/Terms_of_Service.pdf"
              style={{ color: '#5227cb' }}
            >
              Terms of Service
            </Link>{' '}
            and{' '}
            <Link
              href="https://id.gamesboost42.com/resources/mm3fq/login/factoring/pdf/Privacy_Policy.pdf"
              style={{ color: '#5227cb' }}
            >
              Privacy Policy
            </Link>
          </Checkbox>
        </Form.Item>

        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            loading={loading}
            size="large"
            violet
            disabled={!isAgreed}
            style={{ color: '#fff', width: '130px' }}
          >
            Set Password
          </Button>
        </Form.Item>
      </Form>
    </>
  );
};

export default InvitePasswordForm;
